var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',[_c('v-row',[_c('v-col',[_c('p',{staticClass:"text-h2"},[_vm._v("You have logged out!")])])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }